export default __webpack_public_path__ + "static/media/error-page-bg.675b97b5.jpg";